import { useQuery } from '@apollo/client';
import GET_UNPAID_PAYPOINTS from './unpaidPaypoints.gql';

export enum Service {
  FLIGHT = 'flight',
  HOTEL = 'hotel',
  PKGTOUR = 'pkgtour',
}

interface IData {
  unpaidPaypoints: Service;
}

export default function useUnpaidPaypoints() {
  const { loading, data } = useQuery<IData>(GET_UNPAID_PAYPOINTS);
  return { loading, unpaidPaypoints: data?.unpaidPaypoints };
}
